import { REORDER_STORE_STATUS, REORDER_FETCH_MENU, RE_ORDER_ACCEPTED, TENDER_DATA_SET, REORDER_SELECTED_DISPOSITION, SET_REORDER, REORDER_STORE_DISPOSITION, } from '../../constants';
export function getReorderStoreStatus(data, tenantId, successCallback = null, errorCallback = null) {
    return {
        type: REORDER_STORE_STATUS,
        payload: { data, tenantId },
        successCallback,
        errorCallback,
    };
}
export function reorderFetchMenuAction(menuPayload, exclusionPayload, successCallback = null) {
    return {
        type: REORDER_FETCH_MENU,
        menuPayload,
        exclusionPayload,
        successCallback,
    };
}
export function tenderDataAction(tenderInfo, isPaymentAdded) {
    return {
        type: TENDER_DATA_SET,
        tenderInfo,
        isPaymentAdded,
    };
}
export function getReOrderAccepted(payload, successCallback = null, errorCallback = null) {
    return {
        type: RE_ORDER_ACCEPTED,
        payload,
        successCallback,
        errorCallback,
    };
}
export function setReorderSelectedDisposition(payload) {
    return {
        type: REORDER_SELECTED_DISPOSITION,
        payload,
    };
}
export function setReorder(payload) {
    return {
        type: SET_REORDER,
        payload,
    };
}
export function reorderStoreDisposition(payload) {
    return {
        type: REORDER_STORE_DISPOSITION,
        payload,
    };
}
